import SortBullet from './component'

export default SortBullet
